import React, { Component } from 'react';
import { Container, Row, Tabs, Tab, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import GainersListDisplay from './GainersListDisplay';
import LoosersListDisplay from './LoosersListDisplay';
import ActivesListDisplay from './ActivesListDisplay';
// import { useParams } from 'react-router-dom';
//import NewHighListDisplay from './NewHighListDisplay';
import New52HighListDisplay from './New52HighListDisplay';
//import NewLowListDisplay from './NewLowListDisplay';
import New52LowListDisplay from './New52LowListDisplay';
import OverBoughtListDisplay from './OverBoughtListDisplay';
import OverSoldListDisplay from './OverSoldListDisplay';
import UnusualListDisplay from './UnusualListDisplay';
import MostVolatileListDisplay from './MostVolatileListDisplay';
import Paypal from '../dashboard/Paypal';

class GeneralWrapWithParams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: this.props.option
    };
    console.log('GeneralWrap ', this.props);
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Top Gainers, Loosers, Active Stocks</title>
          <link rel="canonical" href="https://www.vizfm.com/stocks" />
          <meta name="description" content="Everyday intraday top Gainers, Loosers, Active stocks" />
        </Helmet>
        <Container fluid className="p-2">
          {/* <Row>
            <Col>General Screener</Col>
          </Row> */}
          {/* <Row>
              <Col><Paypal /></Col>
          </Row> */}
          <Row>
            {/* <Col><GainersListDisplay/></Col> */}
            <Tabs defaultActiveKey={this.state.option} id="uncontrolled-tab-example" className="mb-3">
              <Tab eventKey="gainers" title="Gainers">
                Top Gainers
                <GainersListDisplay />
              </Tab>
              <Tab eventKey="loosers" title="Loosers">
                Top Loosers
                <LoosersListDisplay />
              </Tab>
              <Tab eventKey="active" title="Active">
                Most Active
                <ActivesListDisplay />
              </Tab>
              {/* <Tab eventKey="newHigh" title="New High">
                New High
                <NewHighListDisplay />
              </Tab> */}
              <Tab eventKey="new52High" title="52 Week High">
                52 Week High
                <New52HighListDisplay />
              </Tab>
              {/* <Tab eventKey="newLow" title="New Low">
                New Low
                <NewLowListDisplay />
              </Tab> */}
              <Tab eventKey="new52Low" title="52 Week Low">
                52 Week Low
                <New52LowListDisplay />
              </Tab>      
              <Tab eventKey="overBought" title="Over Bought">
                Over Bought
                <OverBoughtListDisplay />
              </Tab>
              <Tab eventKey="overSold" title="Over Sold">
                Over Sold
                <OverSoldListDisplay />
              </Tab>                
              <Tab eventKey="unusualVolume" title="Unusual Volume">
                Unusual Volume
                <UnusualListDisplay />
              </Tab>       
              <Tab eventKey="mostVolatile" title="Most Volatile">
                Most Volatile
                <MostVolatileListDisplay />
              </Tab>                          

            </Tabs>
          </Row>
        </Container>
      </div>
    );
  }
}

function GeneralWrap(props) {
  // let params = useParams();
  return <GeneralWrapWithParams {...props} />
}

export default GeneralWrap;